<template>
  <div class="payPage">
    <div class="pay" v-if="payInfo">
      <el-row class="centerIE">
        <el-col :span="4"><i class="el-icon-circle-check"></i></el-col>
      </el-row>
      <el-row>
        <el-col><p>已缴费，正在进行缴费审核</p></el-col>
      </el-row>
    </div>
    <div class="payFail" v-else>
      <el-row class="centerIE">
        <el-col :span="4"><i class="el-icon-circle-close"></i></el-col>
      </el-row>
      <el-row>
        <el-col><p>未通过复审</p></el-col>
        <el-col class="failMessage"
          ><p>失败原因:{{ failInfo }}</p></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['payInfo', 'failInfo'])
  },
  methods: {
    payHandle() {
      console.log('前往支付')
      console.log(this.failInfo)
      window.open(this.payHerf, '_blank')
      this.jumpUrl = this.payHerf
      this.payDisable = true
      this.payBtnInfo = '正在缴费'
      this.timePay = setInterval(() => {
        this.getStatus()
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.payPage {
  .pay,
  .payFail {
    color: #67c23a;
    i {
      font-size: 80px;
      margin-top: 50px;
      margin-bottom: 18px;
    }
    p {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 28px;
      line-height: 50px;
    }
    .el-button {
      margin-left: 20px;
    }
  }
  .payFail {
    color: #f56c6c;
    .failMessage {
      text-align: center;
      font-size: 24px;
      line-height: 34px;
      margin: 20px 0;
    }
  }
  @include autoInner;
}
// icon居中
.centerIE {
  transform: translate(45%);
}
</style>
